import React from 'react';
import {
  CalendarIcon, RefreshIcon, VideoCameraIcon, DocumentTextIcon,
} from '@heroicons/react/outline';
import {isEqual} from 'lodash';
import Button, {ButtonSizes, ButtonTypes} from './ButtonNew';

export default function BookingTab({
  coach, credits, trackerEvent, onClickServices, onClickPreviewAvailability,
}) {
  const isNegotiationOnly = isEqual(coach?.Services, ['Negotiation']);
  return (
    <div className="lg:flex flex-col px-6 py-5 pb-4 w-full shadow-sm border border-gray-200 rounded-lg bg-white">
      <span className="text-lg font-semibold">
        {`Book time with ${coach['First name']} now`}
      </span>
      <div className="mt-2 mb-4 flex flex-col text-base font-medium text-gray-500 justify-center space-y-1">
        <span className="flex items-center justify-start">
          <VideoCameraIcon className="w-6 mr-2 text-indigo-600" />
          {isNegotiationOnly ? 'Talk to a professional negotiator' : '1-hour phone or video chat'}
        </span>
        <span className="flex items-center justify-start">
          <DocumentTextIcon className="w-6 mr-2 text-indigo-600" />
          {isNegotiationOnly ? 'Guided by private compensation data' : 'Detailed written feedback'}
        </span>
        <span className="flex items-center justify-start">
          <CalendarIcon className="w-6 mr-2 text-indigo-600" />
          Convenient scheduling
        </span>
        <span className="flex items-center justify-start">
          <RefreshIcon className="w-6 mr-2 text-indigo-600" />
          {isNegotiationOnly ? 'Money-back guarantee available' : 'Switch coaches at any time'}
        </span>
      </div>
      {credits > 0 ? (
        <div className="flex flex-col">
          <Button
            size={ButtonSizes.LARGE}
            className="mb-2 whitespace-nowrap"
            href={`/coaching/booking?coach=${coach.slug}`}
            onClick={() => trackerEvent?.()}
          >
            Book now
            <span className="font-normal text-sm opacity-80">
                  &nbsp;&ndash;&nbsp;
              {credits === 1
                ? '1 session remaining'
                : `${credits} sessions remaining`}
            </span>
          </Button>
          <Button
            size={ButtonSizes.LARGE}
            buttonType={ButtonTypes.TERTIARY}
            onClick={() => onClickPreviewAvailability()}
          >
            Preview availability
          </Button>
        </div>
      ) : (
        <div className="flex flex-col">
          <Button
            size={ButtonSizes.LARGE}
            className="mb-2"
            onClick={() => onClickServices()}
          >
            {isNegotiationOnly ? 'Book a professional negotiator' : 'Select coaching plan'}
          </Button>
          <Button
            size={ButtonSizes.LARGE}
            buttonType={ButtonTypes.TERTIARY}
            onClick={() => onClickPreviewAvailability()}
          >
            Preview availability
          </Button>
        </div>
      )}
    </div>
  );
}
